// extracted by mini-css-extract-plugin
export default {"list":"ListCard_list__7jXoJ","flexColumn":"ListCard_flexColumn__qRsCV","no-data":"ListCard_no-data__keILV","no-data-vertical":"ListCard_no-data-vertical__9Aka-"};